import { db } from '../firebase';

/**
 * Subscribe to leaderboards data.
 */
export const subscribeLeaderboards = (callback) => {
    if (!db) return () => { };

    const leaderboardsRef = db.ref('leaderboards');
    leaderboardsRef.on('value', (snapshot) => {
        callback(snapshot.val() || {});
    });
    return () => leaderboardsRef.off();
};
